import { render, staticRenderFns } from "./navHeaderV2.vue?vue&type=template&id=7440a53a&scoped=true&"
import script from "./navHeaderV2.vue?vue&type=script&lang=js&"
export * from "./navHeaderV2.vue?vue&type=script&lang=js&"
import style0 from "./navHeaderV2.vue?vue&type=style&index=0&id=7440a53a&lang=scss&scoped=true&"
import style1 from "./navHeaderV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7440a53a",
  null
  
)

export default component.exports